export var defaultProps = {
    className: '',
    title: '',
    hasBorder: false,
    size: 'default',
    column: 3,
};
export var itemDefaultProps = {
    className: '',
    label: '',
    span: 1,
};
export var RowDefaultProps = {
    className: '',
    layout: 'horizontal',
    hasBorder: false,
    colon: false,
    row: [],
};
export var CellDefaultProps = {
    className: '',
    span: 1,
    label: '',
    component: 'tr',
    hasBorder: false,
    content: '',
    colon: false,
};
